/**
 * Hook to get the portal contact ID from localStorage.
 * Set during portal login at /digibox/login.
 * Returns null for CRM users (no portal session).
 */
export function usePortalContact(): {
  contactId: string | null;
  contactName: string | null;
  contactEmail: string | null;
  isPortal: boolean;
} {
  try {
    const raw = localStorage.getItem("portal_session");
    if (raw) {
      const session = JSON.parse(raw);
      return {
        contactId: session.contactId || null,
        contactName: session.contactName || null,
        contactEmail: session.contactEmail || null,
        isPortal: true,
      };
    }
  } catch {
    // ignore
  }
  return { contactId: null, contactName: null, contactEmail: null, isPortal: false };
}
